module.exports = __webpack_public_path__ + "f5b2c9fc245bf6c6d3c3b643f82b7ba1.svg";